import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {
  paymentVerficationRequest,
  paymentVerificationResponse,
} from '../lib/types';
import {paymenrVerificationApiCall} from '../api/paymentverification.api';

const paymentData = {
  resultStatus: '',
  resultCode: '',
  resultMsg: '',
};

interface paymentVerificationState {
  paymentVerificationData: paymentVerificationResponse;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: paymentVerificationState = {
  paymentVerificationData: paymentData,
  loading: false,
  error: '',
};

export const paymenrVerification = createAsyncThunk(
  'employee/paymentVerify',
  async (parameters: paymentVerficationRequest, thunkApi) => {
    return paymenrVerificationApiCall(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const paymentVerificationSlice = createSlice({
  name: 'paymentverifies',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetVerifyPaymentState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(paymenrVerification.pending, state => {
      state.loading = true;
    });
    builder.addCase(paymenrVerification.fulfilled, (state, action) => {
      state.loading = false;
      state.paymentVerificationData = action.payload;
    });
    builder.addCase(paymenrVerification.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetVerifyPaymentState} = paymentVerificationSlice.actions;

export const paymentVerifyResponse = (
  state: RootState,
): paymentVerificationResponse =>
  state.paymentVerificationReducer.paymentVerificationData;
export const errorInVerifypayment = (state: RootState): string =>
  state.paymentVerificationReducer.error;
export const verifyPaymentLoading = (state: RootState): boolean =>
  state.paymentVerificationReducer.loading;

export default paymentVerificationSlice.reducer;
